import { ErrorsService } from "src/app/services/common/errors.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { Validators } from "@angular/forms";
import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder } from "@angular/forms";

import { IBranch } from "src/app/interfaces/branch";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { BIDService } from "src/app/services/common/bid.service";
import { ICompany } from "src/app/interfaces/company";
import { ICash } from "src/app/interfaces/cash";
import { CashService } from "src/app/services/http/business/cash/cash.service";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { ICashier } from "src/app/interfaces/cashier";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-assign-cashier',
  templateUrl: './assign-cashier.component.html',
  styleUrls: ['./assign-cashier.component.css'],
  providers: [ErrorsService]
})
export class AssignCashierComponent implements OnInit, OnDestroy {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  personInfo: any;
  isOwner: boolean;
  bracnchId: string;
  errors = new Array();
  companyList: ICompany[];
  branchesList: IBranch[];
  form: FormGroup;
  personNorFound = true;
  userEncryptId: string;

  constructor(
    private fb: FormBuilder,
    private bidService: BIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private contractService: ContractService,
    private cashService: CashService,
    @Inject(MAT_DIALOG_DATA) public data: ICash,
    private dialogRef: MatDialogRef<AssignCashierComponent>
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.createCashierForm();
  }
  // CashId: number;
  // UserEncryptId: string;
  // BranchEncryptId: string;

  createCashierForm() {
    this.form = this.fb.group({
      BranchEncryptId: [this.data.BranchEncryptId, Validators.compose([Validators.required])],
      UserEncryptId: [null, Validators.compose([Validators.required])],
      NationalCode: [null, Validators.compose([Validators.required,Validators.pattern("^[0-9]*$"),
      Validators.minLength(10),
      Validators.maxLength(12)])],
      CashId: [this.data && this.data.Id ? this.data.Id : 0]
    });
  }

  searchUser(form: any) {

    this.errors = new Array();
    this.contractService.GetBranchContractUser(form.BranchEncryptId).subscribe(
      res => {
        var person = res.filter(r => r.NationalCode == form.NationalCode)[0];
        if (person) {
          this.personNorFound = false;
          this.personInfo = person;
          this.userEncryptId = person.UserEncryptId;
        }
        else {
          this.personNorFound = true;
          this.snackBar.OpenSnackBar(
            this.translate.get("error.userNotFound"),
            "ok",
            5000,
            SoundEnum.beep
          );
        }
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }



  submit(form: any) {
    var cashier: ICashier = {
      BranchEncryptId: form.BranchEncryptId,
      CashId: form.CashId,
      UserEncryptId: form.UserEncryptId
    };
    this.errors = new Array();
    this.cashService.personAdd(cashier).subscribe(
      () => {
        this.dialogRef.close();

        this.snackBar.OpenSnackBar(
          this.translate.get("success.cashAdd"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.isOwner) {
      this.bidService.setBID("");
    }
  }

}
